import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getCheckList = (data: IDynamicTableParams) => {
  return instance()
    .post('/orkChecklist/list', data)
    .then((response) => response.data);
};

export const getCheckListAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/orkChecklist/availableColumns')
    .then((response) => response.data);
};

export const getCheckListAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/orkChecklist/availableGroupColumns')
    .then((response) => response.data);
};

export const getImageInfo = (imageName: string) => {
  return instance()
    .post<{ downloadOptimizedUrl: string; downloadThumbnailUrl: string; downloadUrl: string }[]>(
      '/file/getDownloadURL',
      [imageName],
    )
    .then((response) => response.data);
};
